import FacebookLogin from 'react-facebook-login';
import { parseFBResponse } from "../../../utils/index";
import { socialLogin } from "../../../api/auth";
import { RegisterationDone } from "../../../store/actions/registeration";
import { toastr } from 'react-redux-toastr';
import { useDispatch } from "react-redux";
import { AuthSuccess } from "../../../store/actions/auth";
import { useRouter } from 'next/router';


function Facebook(props) {
	const dispatch = useDispatch();
	const router = useRouter();

	const facebookClick = (event) => {
		
	}

	const handleFacebookCallback = (response) => {
		if (response?.status == "unknown") {
			return;
		}
		const parsedData = parseFBResponse(response);
		if (Object.keys(parsedData).length) {
			socialLogin(parsedData).then((res) => {
				if (Object.keys(res).length > 0) {
					if (res?.is_new_user) {
						dispatch(RegisterationDone({ id: res.user_id, email: parsedData.email, name: parsedData.name, source: 'Facebook', token: res.auth_token, isNewUser: res.is_new_user, authenticated: true, avatar: parsedData?.profile_img }));
						router.push('/register/select-gender', "/select-gender", { shallow: true });
					} else if (res?.user_data){
						dispatch(AuthSuccess({ user: res.user_data, token: res.auth_token, profile: res.user_data?.profile, avatar:res.user_data?.image_url }));
						router.push('/home', "/home", { shallow: true });
					}
				}
			});
		} else {
			toastr.error('Sorry!', 'Something went wrong with facebook Login.');
		}
	}

	return (
		<FacebookLogin
			appId={process.env.Facebook_APP_ID}
			autoLoad={false}
			fields="name,email,picture"
			cssClass="facebook-button"
			icon={<img alt={"Facebook"} src={`${process.env.IMAGES_BASE_URL}/static-content/fbook.png.webp`} style={{cursor: 'pointer'}} />}
			textButton=""
			size="small"
			callback={handleFacebookCallback}
			onClick={facebookClick}
		/>
	);
};

export default Facebook;
